import { AuditorForm } from '../mainFormAuditor/components';
import { ocForm } from './components';
import {
  BasicInfoSupplier,
  ActivityAreaForm,
  BankForm,
  DocumentsEquipmentSupplier,
  DocumentsSupplier,
  TermsSupplier,
  ObjectionSupplier,
  } from '../mainFormSupplier/components';
  import { tabs } from '../mainFormSupplier/components/basicInfoSupplier/tabs';
  // import { getLocalString, localNames } from "utils/localisation.service";
  // import locale from 'antd/lib/date-picker/locale/el_GR';

export const stepsOC = ({ isDirectSupplier, isIndirectSupplier }) =>  {
  return [
 {
    name: 'BASICFORMSUPPLIER',
    label: 'Βασικά Στοιχεία Προμηθευτή',
    Component: BasicInfoSupplier,
    tabsComponent : tabs({ isDirectSupplier, isIndirectSupplier }),
    subtabs: true,
    id: 0,
  },
  {
    name: 'AREAFORM',
    label: 'Περιοχή Δραστηριότητας',
    Component: ActivityAreaForm,
    id: 1,
    hidden: !isDirectSupplier,
  },
  {
    name: 'BANKFORM',
    label: 'Στοιχεία Πιστωτικού Ιδρύματος',
    Component: BankForm,
    id: 2,
    hidden: !isDirectSupplier,
  },
  {
    name: 'EQUIPMENTDOCUMENT',
    label: 'Εξοπλισμός',
    Component: DocumentsEquipmentSupplier,
    id: 3,
    hidden: !isIndirectSupplier,
  },
  {
    name: 'DOCUMENTS',
    label: 'Έγγραφα',
    Component: DocumentsSupplier,
    id: 4,
    hidden: !isDirectSupplier,
  },
  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: TermsSupplier,
    id: 5,
  },
  {
    name: 'EVALUATIONFORM',
    label: 'Αξιολόγηση Αίτησης',
    Component: AuditorForm,
    id: 6,
  },
  {
    name: 'OBJECTIONFORM',
    label: 'Ένσταση',
    Component: ObjectionSupplier,
    id: 7,
  },
  {
    name: 'OBJECTIONEVALUATIONFORM',
    label: 'Αξιολόγηση Ένστασης',
    Component: ocForm,
    id: 8,
  },
].filter(item => !item?.hidden)
};